export enum LabelType {
  InnerLabel,
  OuterLabel
}
